module.exports = __webpack_public_path__ + "img/package-gift-blue.af893330.svg";